import { TreeNode } from '../../hooks/stores/launcherElementsStore';

export const findParentID = (tree: TreeNode[], nodeId: string, parent: string | null = null): string | null => {
  for (const node of tree) {
    if (node.id === nodeId) {
      return parent;
    }

    if (node.children) {
      const parentFound = findParentID(node.children, nodeId, node.id);
      if (parentFound) {
        return parentFound;
      }
    }
  }

  return null;
};
